import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ScaleIconContentSupportChat } from '@cloudorder/ui';

import { usePixie } from '@/features/pixie/PixieContext';

import styles from './Pixie.module.css';

/** The top-bar entry point. Deliberately a plain button rather than a Scale one:
    it carries the brand pill treatment the prototype used to mark the assistant
    as something other than a cockpit control. */
export function PixieLauncher(): ReactElement {
  const { open, toggle } = usePixie();
  const { t } = useTranslation('pixie');

  return (
    <button
      type="button"
      className={styles.launcher}
      aria-label={open ? t('panel.close') : t('panel.composerLabel')}
      aria-expanded={open}
      aria-controls="pixie-panel"
      onClick={toggle}
    >
      <ScaleIconContentSupportChat size={14} decorative />
      <span className={styles.launcherLabel}>{t('panel.composerLabel')}</span>
    </button>
  );
}
